/**
 * 共享状态层 — 数据模型 + 全局 FLAG
 * 所有模块从此处导入 data/状态变量，避免循环依赖
 *
 * 设计原则：
 * - 不可变引用：flags 对象可内部修改但引用不变，ESM binding 有效
 * - 所有 DOM 无关的业务状态集中在此，render 函数不在此
 */
export const data = {
    schemaVersion: 1,
    archives: {},
    currentArchive: null,
    currentTime: 'morning',
    // 运行时状态（非持久化）
    _formDirty: false,
    _archiveDirty: false,
    _toastTimer: null
};

/** 整体替换 data（模拟 data = newData 引用替换） */
export function replaceData(newData) {
    Object.keys(data).forEach(k => delete data[k]);
    Object.keys(newData).forEach(k => { data[k] = newData[k]; });
}
